import React, { useState,Fragment } from 'react'
import { LogoutOutlined } from '@ant-design/icons';
import { passwordsResetApi } from '@service';
import GeneralModal from '../general-modal';
import GeneralForm from '../general-form';
import formSchema from './schema';

export default () => {
  const formRef = React.useRef();
  const [displayHooks,setDisplay] = useState(1);

  const onConfirm = async () => {
    const validate = await formRef.current.onConfirm();
    let success = false;

    if (!validate.errorFields) {
      // if(validate.new_pa)
      validate.method = 'post';
      const { flag } = await passwordsResetApi({...validate,ifTip:true});

      if (flag === 200) {
        success = true;
      }
    }
    return {
      success,
    };
  }

  const passwordReset = () => setDisplay(x => x + 2);

  return (
    <Fragment>
      <GeneralModal
        displayHooks={displayHooks}
        title='修改密码'
        onConfirm={onConfirm}
        showBtn={false}
      >
        <GeneralForm
          schema={formSchema}
          ref={formRef}
        />
      </GeneralModal>
      <span className="ml-12" onClick={passwordReset}>
        <LogoutOutlined />
                修改密码
      </span>
    </Fragment>
  )
}